module.exports = __webpack_public_path__ + "img/bridge_true.79549144.png";